// extracted by mini-css-extract-plugin
export default {"add_flow":"addNode_add_flow__0koW-"};